var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiShowHideIconMultiColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#haidiShowHideIconMultiColor_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorPrimary)",
  d: "M15.883 7c-.07-.104-1.017-1.386-2.513-2.61l-.92.92a14.781 14.781 0 0 1 2.086 2.072c-.868 1.05-3.51 3.926-6.53 3.926-.466 0-.92-.065-1.36-.188l-.278.278-.752.752a6.879 6.879 0 0 0 2.397.453c4.34 0 7.734-4.644 7.877-4.845a.652.652 0 0 0 0-.758h-.007Zm-3.569-3.394-.609.609-.324.33.94-.94h-.007ZM11.148 2.938l-.486.486-.486.493h-.006c-.68-.285-1.412-.467-2.164-.467-1.21 0-2.364.46-3.361 1.082-1.497.933-2.65 2.215-3.168 2.85.46.564 1.431 1.646 2.701 2.533l-.933.933a15.244 15.244 0 0 1-3.122-3.09.652.652 0 0 1 0-.758c.143-.194 3.537-4.845 7.883-4.845 1.128 0 2.184.31 3.142.783Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#154FA6",
  d: "M10 4.366 6.007 8C5.386 7.482 5 6.74 5 5.911c0-.376.084-.737.23-1.062C6.09 4.36 7.085 4 8.131 4c.649 0 1.28.142 1.868.366Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M11.22 4.707 6.671 9.254l4.541-4.547h.006Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorPrimary)",
  d: "m14.251 1.675-1.93 1.93h-.007l-.609.61-.324.33h-.013s.007 0 .007.013l-.156.155h-.006l-4.54 4.548-.085.084-1.263 1.27h-.007l-2.59 2.59a.676.676 0 0 1-.46.188.676.676 0 0 1-.46-.187.645.645 0 0 1 0-.914l2.37-2.37 1.367-1.367 4.625-4.632h.007l.485-.492L13.286.8a.653.653 0 0 1 .965.874Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M11.213 4.707h.006L6.672 9.254l4.541-4.547ZM12.32 3.606l-.939.939.324-.33.61-.61h.006Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.22 4.707 6.671 9.254l4.541-4.547h.006ZM12.32 3.606l-.939.939.324-.33.61-.61h.006Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "haidiShowHideIconMultiColor_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .613h16v12.774H0z"
})))));
export default SvgHaidiShowHideIconMultiColor;